export const zhCN = {
    common: {
        appName: 'Supadown',
        accept: '接受',
        cancel: '取消',
        loading: '加载中...',
        back: '返回',
        notFound: '404',
        notFoundBody: '该页面不存在。',
        skipToContent: '跳至内容',
        language: '语言',
        toggleTheme: '切换主题',
        themeLight: '浅色',
        themeDark: '深色',
        themeSystem: '系统',
    },
    nav: {
        legal: '条款与隐私',
        backHome: '返回首页',
        howTo: '如何复制链接',
    },
    home: {
        tagline: '粘贴链接，即刻下载。',
        seoHeading: '免费在线下载YouTube、Instagram和TikTok视频',
        seoDescription: 'Supadown是免费的在线视频下载器。下载YouTube、Instagram Reels、TikTok、Facebook、X (Twitter)、LinkedIn、Kwai和Pinterest的视频。无需安装，无需注册。',
        paste: '粘贴视频链接',
        analyze: '分析',
        download: '下载',
        downloading: '下载中...',
        invalidUrl: '链接无效，请粘贴完整的视频链接。',
        unsupported: '暂不支持该平台。',
        serverError: '出了点问题，请稍后再试。',
        details: '视频详情',
        channel: '频道',
        duration: '时长',
        views: '播放量',
        quality: '画质',
        supportedPlatforms: '支持的平台',
    },
    platforms: {
        items: {
            youtube: { name: 'YouTube', description: '公开视频、Shorts 和直播' },
            instagram: { name: 'Instagram', description: '公开帖子、Reels 和快拍' },
            facebook: { name: 'Facebook', description: '公开 Facebook 视频' },
            twitter: { name: 'Twitter / X', description: '公开推文中的视频' },
            linkedin: { name: 'LinkedIn', description: '公开帖子与 LinkedIn Learning' },
            tiktok: { name: 'TikTok', description: '公开 TikTok 视频' },
            kwai: { name: 'Kwai', description: '公开 Kwai 视频' },
            pinterest: { name: 'Pinterest', description: '视频 Pin' },
        },
    },
    legal: {
        pageTitle: '条款与隐私',
        intro: 'Supadown 仅供个人、教育、新闻和公共内容存档使用。请尊重各平台的版权和使用条款。',
        privacy: { title: '隐私', body: '下载完成后不会存储任何链接。日志已匿名处理。IP 地址截断为 /24 段并在 24 小时后删除。不使用任何跟踪 Cookie。' },
        contact: { title: '联系方式', body: '问题、滥用举报或删除请求：hello@supadown.com。' },
    },
    legalGate: {
        title: '继续前请阅读',
        body: 'Supadown 仅供公开内容和合法用途使用（个人存档、教育、研究、新闻报道）。请尊重各平台的版权。',
        contactLine: '问题或删除请求：hello@supadown.com。',
    },
    footer: { copyright: '© Supadown', contact: 'hello@supadown.com' },
    seo: {
        faqTitle: '常见问题',
        faqGuideLink: '查看分步指南 →',
        faq: [
            { q: '如何下载YouTube视频？', a: '将YouTube链接粘贴到上方输入框，点击搜索按钮。Supadown会分析视频并显示下载选项。' },
            { q: 'Supadown免费吗？', a: '是的，Supadown完全免费。无需注册，没有隐藏费用。' },
            { q: 'Supadown会存储我的数据吗？', a: '不会。下载完成后我们不会存储任何URL或个人数据。不使用任何跟踪Cookie。' },
            { q: '支持哪些平台？', a: 'YouTube、Instagram、TikTok、Facebook、X (Twitter)、LinkedIn、Kwai和Pinterest。' },
            { q: '需要安装任何东西吗？', a: '不需要。Supadown直接在浏览器中运行。无需应用、扩展或软件。' },
            { q: '如何下载Instagram Reels？', a: '在Instagram中复制Reel链接，粘贴到Supadown，点击搜索按钮。几秒钟内即可下载。' },
            { q: 'Supadown可以在手机上使用吗？', a: '可以。Supadown可在任何有浏览器的设备上使用——手机、平板或电脑。无需安装任何东西。' },
            { q: '如何下载TikTok视频？', a: '将TikTok链接粘贴到Supadown。视频将以最佳画质下载。' },
            { q: '可以下载HD或4K视频吗？', a: '可以。Supadown显示所有可用画质选项——从360p到4K——供您选择。' },
            { q: '如何下载YouTube Shorts？', a: '复制YouTube Short链接并粘贴到Supadown。Shorts与普通视频一样处理。' },
            { q: 'Supadown需要注册吗？', a: '不需要。无需注册。只需粘贴链接并下载。' },
            { q: '可以只下载音频吗？', a: '可以。当源平台提供音频选项时，Supadown会显示单独的音频下载选项。' },
        ],
    },
    howTo: {
        title: '如何复制视频链接',
        intro: '要下载视频，您需要从原始平台复制视频链接。以下是各平台的操作方法：',
        tryIt: '立即下载',
        platforms: {
            youtube: { title: 'YouTube', steps: ['在YouTube上打开视频（应用或浏览器）。', '点击视频下方的"分享"。', '点击"复制链接"。', '将链接粘贴到Supadown，点击搜索按钮。'] },
            instagram: { title: 'Instagram', steps: ['在Instagram上打开帖子或Reel。', '点击右上角的三个点（⋯）。', '点击"复制链接"。', '将链接粘贴到Supadown。'] },
            tiktok: { title: 'TikTok', steps: ['在TikTok上打开视频。', '点击"分享"按钮（箭头图标）。', '点击"复制链接"。', '将链接粘贴到Supadown。'] },
            facebook: { title: 'Facebook', steps: ['在Facebook上打开视频或Reel。', '点击帖子右上角的三个点（⋯）。', '点击"复制链接"。', '将链接粘贴到Supadown。'] },
            twitter: { title: 'X (Twitter)', steps: ['在X上打开包含视频的推文。', '点击分享按钮（箭头图标）。', '点击"复制链接"。', '将链接粘贴到Supadown。'] },
            linkedin: { title: 'LinkedIn', steps: ['在LinkedIn上打开包含视频的帖子。', '点击右上角的三个点（⋯）。', '点击"复制帖子链接"。', '将链接粘贴到Supadown。'] },
            kwai: { title: 'Kwai', steps: ['在Kwai上打开视频。', '点击"分享"按钮。', '点击"复制链接"。', '将链接粘贴到Supadown。'] },
            pinterest: { title: 'Pinterest', steps: ['在Pinterest上打开视频Pin。', '点击分享按钮。', '点击"复制链接"。', '将链接粘贴到Supadown。'] },
        },
    },
    platformSeo: {
        otherPlatforms: '其他平台',
        youtube: { chipLabel: 'YouTube', title: '免费下载YouTube视频', description: '免费下载YouTube高清和4K视频。Supadown是最快、最安全的YouTube下载器。无需安装，无需注册。', heading: '免费在线下载YouTube视频', intro: 'Supadown可以下载任何画质的YouTube视频，从360p到4K。支持普通视频、Shorts和公开直播。只需粘贴视频链接，选择画质，点击下载。无需安装软件或扩展。', cta: '立即下载YouTube视频 →', faq: [{ q: '可以下载4K的YouTube视频吗？', a: '可以。Supadown显示所有可用分辨率，包括720p、1080p、1440p和4K。' }, { q: '如何下载YouTube Shorts？', a: '复制Short链接粘贴到Supadown。Shorts与普通视频一样处理——选择画质即可下载。' }, { q: '可以只下载YouTube视频的音频吗？', a: '可以。Supadown会显示单独的音频选项（M4A），非常适合音乐和播客。' }] },
        instagram: { chipLabel: 'Instagram', title: '免费下载Instagram视频', description: '免费下载Reels、Stories和Instagram视频。快速下载器，无需注册。', heading: '免费在线下载Instagram视频和Reels', intro: '下载Instagram视频，包括Reels、Stories和视频帖子。Supadown分析链接并以最佳画质提供下载。', cta: '立即下载Instagram视频 →', faq: [{ q: '可以下载Instagram Reels吗？', a: '可以。复制Reel链接粘贴到Supadown，视频将以原始画质下载。' }, { q: '可以下载Instagram Stories吗？', a: '可以，前提是个人资料是公开的。' }, { q: '可以下载私人账号的内容吗？', a: '不可以。Supadown只下载公开账号的内容。' }] },
        tiktok: { chipLabel: 'TikTok', title: '免费下载TikTok视频', description: '免费在线下载TikTok视频。快速下载器，无需注册。', heading: '免费在线下载TikTok视频', intro: '使用Supadown快速下载TikTok视频。粘贴视频链接，点击搜索，以最佳画质下载。', cta: '立即下载TikTok视频 →', faq: [{ q: 'TikTok视频下载后有水印吗？', a: 'Supadown以平台提供的最佳画质下载视频。水印取决于TikTok上的视频来源。' }, { q: '可以在手机上下载TikTok吗？', a: '可以。Supadown可在任何手机浏览器上使用。' }, { q: '下载需要TikTok账号吗？', a: '不需要。只需要公开视频的链接。' }] },
        facebook: { chipLabel: 'Facebook', title: '免费下载Facebook视频', description: '免费下载Facebook视频和Reels。快速在线下载器，无需注册。', heading: '免费在线下载Facebook视频', intro: '下载公开的Facebook视频，包括Reels和页面视频。将链接粘贴到Supadown，选择画质并下载。', cta: '立即下载Facebook视频 →', faq: [{ q: '可以下载Facebook Reels吗？', a: '可以。复制Reel链接粘贴到Supadown即可。' }, { q: '可以下载群组视频吗？', a: '仅限公开群组和公开视频。' }, { q: '视频画质如何？', a: 'Supadown显示所有可用画质，通常包括高清（720p）和全高清（1080p）。' }] },
        twitter: { chipLabel: 'X (Twitter)', title: '免费下载X (Twitter)视频', description: '免费在线下载X (Twitter)视频。快速下载器，无需注册。', heading: '免费在线下载X (Twitter)视频', intro: '从X（原Twitter）公开推文中下载视频。粘贴推文链接到Supadown，选择画质下载。', cta: '立即下载X视频 →', faq: [{ q: '如何获取推文链接？', a: '打开推文，点击分享按钮，然后点击"复制链接"。' }, { q: '可以下载受保护的推文吗？', a: '不可以。只能下载公开账号的推文。' }, { q: 'Twitter的GIF可以下载吗？', a: '可以。Twitter上的GIF实际上是循环短视频——Supadown会将其下载为MP4。' }] },
        linkedin: { chipLabel: 'LinkedIn', title: '免费下载LinkedIn视频', description: '免费下载LinkedIn视频。公开帖子视频在线下载器。', heading: '免费在线下载LinkedIn视频', intro: '使用Supadown下载LinkedIn公开帖子中的视频。粘贴帖子链接，分析并下载。', cta: '立即下载LinkedIn视频 →', faq: [{ q: '可以下载LinkedIn Learning的视频吗？', a: 'Supadown适用于公开的LinkedIn帖子。LinkedIn Learning视频受订阅保护。' }, { q: '视频会损失画质吗？', a: '不会。Supadown以作者发布的原始画质下载。' }] },
        kwai: { chipLabel: 'Kwai', title: '免费下载Kwai视频', description: '免费在线下载Kwai视频。快速下载器，无需注册。', heading: '免费在线下载Kwai视频', intro: '使用Supadown快速下载Kwai视频。在Kwai应用中复制视频链接，粘贴到Supadown即可下载。', cta: '立即下载Kwai视频 →', faq: [{ q: '如何获取Kwai视频链接？', a: '在Kwai应用中打开视频，点击"分享"，然后点击"复制链接"。' }, { q: '支持任何国家的Kwai视频吗？', a: '是的。Supadown支持任何地区的Kwai链接。' }] },
        pinterest: { chipLabel: 'Pinterest', title: '免费下载Pinterest视频', description: '免费下载Pinterest视频和动画Pin。在线下载器，无需注册。', heading: '免费在线下载Pinterest视频', intro: '使用Supadown下载Pinterest视频Pin。复制Pin链接，粘贴到Supadown即可下载。', cta: '立即下载Pinterest视频 →', faq: [{ q: '可以下载图片Pin吗？', a: 'Supadown专注于视频。图片请使用Pinterest自带的保存按钮。' }, { q: '支持Idea Pin吗？', a: '是的，前提是Idea Pin包含视频。' }] },
    },
};
